<template>
    <div>
        <!-- 页面横幅 -->
        <section class="bg-gradient-to-r from-[#0D47A1] to-[#1976D2] py-20 text-white">
            <div class="max-w-[1200px] mx-auto px-4 flex items-center justify-between">
                <div class="max-w-2xl">

                    <h2 class="text-4xl font-bold mb-6">数据资产质量评价</h2>
                    <p class="text-xl text-blue-100 leading-relaxed opacity-90">
                        通过多维度的质量度量与评估体系，为公共数据资源提供科学、权威的质量标签，驱动数据从“原始资源”向“高质量资产”转化。
                    </p>
                </div>
                <div class="hidden lg:block">
                    <span class="iconify text-[160px] text-white/20" data-icon="ri:medal-line"></span>
                </div>
            </div>
        </section>
        <!-- ==================== 六大评估维度 ==================== -->
        <section class="py-16 bg-white">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-16">
                    <div class="flex items-center justify-center mb-4">
                        <span class="text-2xl text-[#1565C0] font-bold mr-2">●</span>
                        <h3 class="text-2xl font-bold text-gray-800">六大评估维度</h3>
                    </div>
                    <p class="text-[#666666]">依据国家标准《数据质量评价指标》构建的权威评价模型</p>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <!-- 维度 1 -->
                    <div
                        class="bg-white p-8 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                        <div class="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-6">
                            <span class="iconify text-[#1565C0] text-2xl" data-icon="ri:checkbox-circle-line"></span>
                        </div>
                        <h4 class="text-lg font-bold mb-3">规范性</h4>
                        <p class="text-sm text-[#666666] leading-relaxed">校验数据格式、类型及长度是否严格遵循预定义的数据字典与行业元数据标准。</p>
                    </div>
                    <!-- 维度 2 -->
                    <div
                        class="bg-white p-8 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                        <div class="w-12 h-12 bg-green-50 rounded-lg flex items-center justify-center mb-6">
                            <span class="iconify text-[#00BFA5] text-2xl" data-icon="ri:pie-chart-line"></span>
                        </div>
                        <h4 class="text-lg font-bold mb-3">完整性</h4>
                        <p class="text-sm text-[#666666] leading-relaxed">检测数据元素是否缺失，评估数据记录及关联关系在采样范围内的覆盖程度。</p>
                    </div>
                    <!-- 维度 3 -->
                    <div
                        class="bg-white p-8 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                        <div class="w-12 h-12 bg-orange-50 rounded-lg flex items-center justify-center mb-6">
                            <span class="iconify text-[#FF9800] text-2xl" data-icon="ri:repeat-line"></span>
                        </div>
                        <h4 class="text-lg font-bold mb-3">一致性</h4>
                        <p class="text-sm text-[#666666] leading-relaxed">评估不同来源、不同批次间数据逻辑是否统一，确保跨系统数据交互无误差。</p>
                    </div>
                    <!-- 维度 4 -->
                    <div
                        class="bg-white p-8 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                        <div class="w-12 h-12 bg-purple-50 rounded-lg flex items-center justify-center mb-6">
                            <span class="iconify text-purple-600 text-2xl" data-icon="ri:timer-line"></span>
                        </div>
                        <h4 class="text-lg font-bold mb-3">时效性</h4>
                        <p class="text-sm text-[#666666] leading-relaxed">分析数据更新频率与延迟情况，确保决策所依据的数据能够反映当前客观事实。</p>
                    </div>
                    <!-- 维度 5 -->
                    <div
                        class="bg-white p-8 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                        <div class="w-12 h-12 bg-cyan-50 rounded-lg flex items-center justify-center mb-6">
                            <span class="iconify text-cyan-600 text-2xl" data-icon="ri:focus-3-line"></span>
                        </div>
                        <h4 class="text-lg font-bold mb-3">准确性</h4>
                        <p class="text-sm text-[#666666] leading-relaxed">比对权威库或历史基准，校验数值、逻辑及业务表达是否真实反映实体特征。</p>
                    </div>
                    <!-- 维度 6 -->
                    <div
                        class="bg-white p-8 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                        <div class="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center mb-6">
                            <span class="iconify text-red-500 text-2xl" data-icon="ri:shield-flash-line"></span>
                        </div>
                        <h4 class="text-lg font-bold mb-3">安全性</h4>
                        <p class="text-sm text-[#666666] leading-relaxed">扫描敏感字段及隐私隔离情况，评价数据在加工利用过程中的安全合规表现。</p>
                    </div>
                </div>
            </div>
        </section>
        <!-- ==================== 标准化评价流程 ==================== -->
        <section class="py-20 bg-gray-50">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-16">
                    <div class="flex items-center justify-center mb-4">
                        <span class="text-2xl text-[#1565C0] font-bold mr-2">●</span>
                        <h3 class="text-2xl font-bold text-gray-800">四大标准化评价流程</h3>
                    </div>
                    <p class="text-[#666666]">创新性地将传统质量指标与AI智能诊断相结合，实现动态化质量评估</p>
                </div>
                <div class="relative flex justify-between items-start">
                    <div class="absolute top-10 left-0 w-full h-0.5 bg-blue-100 -z-0"></div>
                    <!-- Step 1 -->
                    <div class="flex flex-col items-center w-64 relative z-10">
                        <div
                            class="w-20 h-20 rounded-full bg-blue-600 text-white flex items-center justify-center shadow-lg border-4 border-white mb-6">
                            <span class="iconify text-3xl" data-icon="ri:database-2-line"></span>
                        </div>
                        <h5 class="font-bold mb-2">数据采样</h5>
                        <p class="text-xs text-[#999999] text-center px-4">通过安全沙箱导出非脱敏或部分脱敏样本数据</p>
                    </div>
                    <!-- Step 2 -->
                    <div class="flex flex-col items-center w-64 relative z-10">
                        <div
                            class="w-20 h-20 rounded-full bg-blue-600 text-white flex items-center justify-center shadow-lg border-4 border-white mb-6">
                            <span class="iconify text-3xl" data-icon="ri:test-tube-line"></span>
                        </div>
                        <h5 class="font-bold mb-2">规则匹配</h5>
                        <p class="text-xs text-[#999999] text-center px-4">自动加载行业质量标准及业务自定义验证规则</p>
                    </div>
                    <!-- Step 3 -->
                    <div class="flex flex-col items-center w-64 relative z-10">
                        <div
                            class="w-20 h-20 rounded-full bg-blue-600 text-white flex items-center justify-center shadow-lg border-4 border-white mb-6">
                            <span class="iconify text-3xl" data-icon="ri:shake-hands-line"></span>
                        </div>
                        <h5 class="font-bold mb-2">自动探测</h5>
                        <p class="text-xs text-[#999999] text-center px-4">AI算法深度探测隐形质量缺陷并生成异常报告</p>
                    </div>
                    <!-- Step 4 -->
                    <div class="flex flex-col items-center w-64 relative z-10">
                        <div
                            class="w-20 h-20 rounded-full bg-[#00BFA5] text-white flex items-center justify-center shadow-lg border-4 border-white mb-6">
                            <span class="iconify text-3xl" data-icon="ri:file-text-line"></span>
                        </div>
                        <h5 class="font-bold mb-2">报告发布</h5>
                        <p class="text-xs text-[#999999] text-center px-4">系统自动核算最终质量分值并颁发评价证书</p>
                    </div>
                </div>
            </div>
        </section>
        <!-- ==================== 雷达图展示 ==================== -->
        <section class="py-20 bg-white">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-16">
                    <div class="flex items-center justify-center mb-4">
                        <span class="text-2xl text-[#1565C0] font-bold mr-2">●</span>
                        <h3 class="text-2xl font-bold text-gray-800">六大维度评分雷达图</h3>
                    </div>
                    <p class="text-[#666666]">自动生成可视化评估报告，直观展示数据质量得分</p>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
                    <div class="bg-gray-50 p-8 rounded-2xl border-2 border-dashed border-blue-100">
                        <div class="text-center mb-6">
                            <h4 class="text-xl font-bold text-blue-600 mb-2">样本数据质量雷达图</h4>
                            <p class="text-sm text-gray-500">基于专家评价体系的标准化评分展示</p>
                        </div>
                        <div class="flex items-center justify-center h-64 bg-white rounded-lg shadow-sm border p-4">
                            <svg width="100%" height="100%" viewBox="0 0 400 400" class="max-w-full max-h-full">
                                <!-- 网格背景 -->
                                <g stroke="#e5e7eb" stroke-width="1" fill="none">
                                    <polygon points="200,50 350,125 350,275 200,350 50,275 50,125" fill="#f8fafc" />
                                    <polygon points="200,100 300,150 300,250 200,300 100,250 100,150" fill="#f1f5f9" />
                                    <polygon points="200,150 250,175 250,225 200,250 150,225 150,175" fill="#e2e8f0" />
                                </g>

                                <!-- 雷达图数据区域 -->
                                <polygon points="200,150 300,175 280,250 200,300 120,250 100,175" fill="#3b82f6"
                                    fill-opacity="0.3" stroke="#3b82f6" stroke-width="2" />

                                <!-- 维度轴线 -->
                                <g stroke="#9ca3af" stroke-width="1" stroke-dasharray="4,4">
                                    <line x1="200" y1="50" x2="200" y2="350" />
                                    <line x1="50" y1="125" x2="350" y2="125" />
                                    <line x1="50" y1="275" x2="350" y2="275" />
                                    <line x1="100" y1="75" x2="300" y2="325" />
                                    <line x1="300" y1="75" x2="100" y2="325" />
                                </g>

                                <!-- 维度标签 -->
                                <g font-size="12" fill="#374151" text-anchor="middle">
                                    <text x="200" y="40">规范性</text>
                                    <text x="360" y="125">完整性</text>
                                    <text x="360" y="275">一致性</text>
                                    <text x="200" y="370">时效性</text>
                                    <text x="40" y="275">准确性</text>
                                    <text x="40" y="125">安全性</text>
                                </g>

                                <!-- 得分标签 -->
                                <g font-size="10" fill="#3b82f6" text-anchor="middle" font-weight="bold">
                                    <text x="200" y="140">85%</text>
                                    <text x="290" y="165">78%</text>
                                    <text x="270" y="260">92%</text>
                                    <text x="200" y="290">88%</text>
                                    <text x="130" y="260">82%</text>
                                    <text x="110" y="165">90%</text>
                                </g>
                            </svg>
                        </div>
                    </div>
                    <div class="space-y-6">
                        <h4 class="text-xl font-bold text-gray-800 mb-6">自动化质量评估报告</h4>
                        <div class="space-y-4">
                            <div class="flex items-start space-x-4 p-4 bg-blue-50 rounded-lg">
                                <span class="iconify text-blue-600 text-xl mt-1 flex-shrink-0"
                                    data-icon="ri:file-text-line"></span>
                                <div>
                                    <h5 class="font-bold mb-1">报告自动生成</h5>
                                    <p class="text-sm text-gray-600">系统自动生成包含雷达图、得分明细和质量改进建议的完整评估报告</p>
                                </div>
                            </div>
                            <div class="flex items-start space-x-4 p-4 bg-green-50 rounded-lg">
                                <span class="iconify text-green-600 text-xl mt-1 flex-shrink-0"
                                    data-icon="ri:user-heart-line"></span>
                                <div>
                                    <h5 class="font-bold mb-1">专家评价体系</h5>
                                    <p class="text-sm text-gray-600">基于行业专家制定的标准化评价体系，符合《GB/T 数据质量评价指标》等规范性文件要求</p>
                                </div>
                            </div>
                            <div class="flex items-start space-x-4 p-4 bg-purple-50 rounded-lg">
                                <span class="iconify text-purple-600 text-xl mt-1 flex-shrink-0"
                                    data-icon="ri:line-chart-line"></span>
                                <div>
                                    <h5 class="font-bold mb-1">资产变现基础</h5>
                                    <p class="text-sm text-gray-600">高质量评分为数据资产挂牌交易、融资抵押等变现环节提供权威信用背书</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- ==================== 质量评价价值 ==================== -->
        <section class="py-20 bg-gray-50">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-16">
                    <div class="flex items-center justify-center mb-4">
                        <span class="text-2xl text-[#1565C0] font-bold mr-2">●</span>
                        <h3 class="text-2xl font-bold text-gray-800">质量评价是数据资产变现的关键一步</h3>
                    </div>
                    <p class="text-[#666666]">权威评分为数据资源价值转化提供核心支撑</p>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                    <div class="rounded-2xl overflow-hidden shadow-2xl relative">
                        <img alt="Illustration of digital dashboard showing data quality metrics and growth charts"
                            class="w-full h-auto" id="img-1"
                            src="https://modao.cc/agent-py/media/generated_images/2025-12-19/9b20b30d2dd142c7a3142d57d8a6bbd0.jpg" />
                        <div class="absolute inset-0 bg-blue-900/10"></div>
                    </div>
                    <div>
                        <h3 class="text-3xl font-bold text-[#1565C0] mb-8 leading-tight">通过质量评价<br />开启数据资产升值之旅</h3>
                        <div class="space-y-6">
                            <div class="flex items-start space-x-4">
                                <div
                                    class="mt-1 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                                    <span class="iconify text-[#1565C0] text-sm" data-icon="ri:check-line"></span>
                                </div>
                                <div>
                                    <h5 class="font-bold mb-1">权威信用背书</h5>
                                    <p class="text-[#666666] text-sm">官方认证的质量评分是数据进入资产评估、融资质押的核心前提条件。</p>
                                </div>
                            </div>
                            <div class="flex items-start space-x-4">
                                <div
                                    class="mt-1 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                                    <span class="iconify text-[#1565C0] text-sm" data-icon="ri:check-line"></span>
                                </div>
                                <div>
                                    <h5 class="font-bold mb-1">精准定位痛点</h5>
                                    <p class="text-[#666666] text-sm">详尽的异常数据报告帮助管理部门有的放矢地进行系统升级与治理。</p>
                                </div>
                            </div>
                            <div class="flex items-start space-x-4">
                                <div
                                    class="mt-1 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                                    <span class="iconify text-[#1565C0] text-sm" data-icon="ri:check-line"></span>
                                </div>
                                <div>
                                    <h5 class="font-bold mb-1">提升流通价值</h5>
                                    <p class="text-[#666666] text-sm">高评分的数据资源在要素市场上具备更强的议价能力与市场竞争力。</p>
                                </div>
                            </div>
                        </div>
                        <div class="mt-10">
                            <button @click="toQualityApply"
                                class="bg-[#1565C0] hover:bg-[#0D47A1] text-white px-8 py-3 rounded-lg font-bold shadow-lg transition-all flex items-center">
                                开启质量评测 <span class="iconify ml-2" data-icon="ri:arrow-right-line"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }

    },
    methods: {
        toQualityApply() {

            this.$router.push('/DataQuality')

        }
    },

}
</script>

<style></style>